/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutTargetType } from './rolloutTargetType';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsDeploymentStateEnum } from './vcdsDeploymentStateEnum';
import { VcdsDeploymentCommerce } from './vcdsDeploymentCommerce';
import { VcdsDeploymentStats } from './vcdsDeploymentStats';
import { OperatorVcdsDeploymentNetwork } from './operatorVcdsDeploymentNetwork';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';
import { OperatorVcdsDeploymentApplicationAndInfraHealth } from './operatorVcdsDeploymentApplicationAndInfraHealth';
import { OperatorVcdsDeploymentCloudProvider } from './operatorVcdsDeploymentCloudProvider';
import { VcdsDeploymentSystemIssue } from './vcdsDeploymentSystemIssue';
import { MonitorMinResponse } from './monitorMinResponse';
import { IrrCertMinResponse } from './irrCertMinResponse';
import { VcdsDeploymentInventoryTree } from './vcdsDeploymentInventoryTree';
import { VcdsDeploymentVersion } from './vcdsDeploymentVersion';


export interface DeploymentTargetResponse { 
    /**
     * Org Id
     */
    org_id?: string;
    /**
     * Deployment Id
     */
    deployment_id?: string;
    service_type?: ServiceTypeEnum;
    vcds_service_type?: VcdsServiceTypeEnum;
    state?: VcdsDeploymentStateEnum;
    /**
     * Deployment name
     */
    name?: string;
    /**
     * Deployment secondary name
     */
    secondary_name?: string;
    vmware_managed?: boolean;
    discovered?: boolean;
    login_allowed?: boolean;
    cloud_provider?: OperatorVcdsDeploymentCloudProvider;
    network?: OperatorVcdsDeploymentNetwork;
    version?: VcdsDeploymentVersion;
    commerce?: VcdsDeploymentCommerce;
    inventory?: VcdsDeploymentInventoryTree;
    personas?: Array<string>;
    /**
     * Created by user
     */
    created_by?: string;
    /**
     * Deployment creation date time
     */
    created_time?: Date;
    /**
     * Deleted by user
     */
    deleted_by?: string;
    /**
     * Deployment deletion date time
     */
    deleted_time?: Date;
    /**
     * Last reported date time of inventory, usage or health from agent
     */
    last_reported_time?: Date;
    /**
     * Deployment last updated date time
     */
    last_updated_time?: Date;
    stats?: VcdsDeploymentStats;
    system_issues?: Array<VcdsDeploymentSystemIssue>;
    tasks?: Array<string>;
    health?: OperatorVcdsDeploymentApplicationAndInfraHealth;
    monitor?: MonitorMinResponse;
    irr_cert?: IrrCertMinResponse;
    type?: RolloutTargetType;
    /**
     * Name of the org.
     */
    org_name?: string;
    /**
     * Type of the org.
     */
    org_type?: string;
}
export namespace DeploymentTargetResponse {
}


